var _mask, _path, _rect, _mask2, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 70,
    viewBox: "0 0 52 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2001_11066",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5636 23.3279C40.283 23.3279 51.9474 27.2158 51.9474 33.0478V48.5997C51.2015 53.9601 49.5702 56.1206 44.1714 58.3196V69.9836H15.0116V44.5792L9.57593 66.3178C8.92483 68.9217 6.28611 70.5048 3.68219 69.8537C1.07828 69.2026 -0.504794 66.5639 0.146309 63.96L7.95275 32.7401C7.96248 32.7011 7.97266 32.6624 7.98328 32.624L7.98028 32.6225C9.31886 27.3489 20.8442 23.3279 30.5636 23.3279Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5636 23.3279C40.283 23.3279 51.9474 27.2158 51.9474 33.0478V48.5997C51.2015 53.9601 49.5702 56.1206 44.1714 58.3196V69.9836H15.0116V44.5792L9.57593 66.3178C8.92483 68.9217 6.28611 70.5048 3.68219 69.8537C1.07828 69.2026 -0.504794 66.5639 0.146309 63.96L7.95275 32.7401C7.96248 32.7011 7.97266 32.6624 7.98328 32.624L7.98028 32.6225C9.31886 27.3489 20.8442 23.3279 30.5636 23.3279Z",
    stroke: "#1B1E59",
    strokeWidth: 4,
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1_2001_11066)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.3237,
    y: 25.7275,
    width: 1.94399,
    height: 17.2167,
    transform: "rotate(-24.6122 23.3237 25.7275)",
    fill: "#1B1E59",
    stroke: "#1B1E59",
    strokeWidth: 1.94399
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_2001_11066",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2344 46.6562C23.2344 43.4353 25.8454 40.8242 29.0663 40.8242H48.5062V48.6002C48.5062 51.8211 45.8952 54.4321 42.6743 54.4321H23.2344V46.6562Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2344 46.6562C23.2344 43.4353 25.8454 40.8242 29.0663 40.8242H48.5062V48.6002C48.5062 51.8211 45.8952 54.4321 42.6743 54.4321H23.2344V46.6562Z",
    fill: "#05F29B",
    stroke: "#1B1E59",
    strokeWidth: 4,
    mask: "url(#path-3-inside-2_2001_11066)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9004,
    y: 1,
    width: 19.3839,
    height: 19.3839,
    rx: 9.69193,
    stroke: "#1B1E59",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPatient);
export default __webpack_public_path__ + "static/media/Icon_Patient.80f504b30001f91ffe40255bbd0fdfaf.svg";
export { ForwardRef as ReactComponent };